function renderTemplate(template, args = {}) {
  return String(template ?? '').replace(/{{\s*([^}]+)\s*}}/g, (match, key) => {
    const value = args[key.trim()];
    return value === undefined || value === null ? match : String(value);
  });
}

function localizedArgs(args, nativeArgNames, terms) {
  const nativeNames = new Set(nativeArgNames || []);
  return Object.fromEntries(
    Object.entries(args || {}).map(([key, value]) => [
      key,
      nativeNames.has(key) ? terms[String(value)] || value : value,
    ]),
  );
}

export function localizeExercisePack(pack, locale) {
  if (!pack || !locale) return pack;
  const strings = locale.strings || {};
  const terms = locale.terms || {};
  const translated = (key, args, nativeArgs) => {
    if (!key || !strings[key]) return null;
    return renderTemplate(strings[key], localizedArgs(args, nativeArgs, terms));
  };

  return {
    ...pack,
    title: translated('pack.title', { number: pack.id }) || pack.title,
    description: translated('pack.description') || pack.description,
    level: translated(pack.levelKey) || pack.level,
    questions: (pack.questions || []).map((question) => ({
      ...question,
      category: translated(question.categoryKey) || question.category,
      question: translated(
        question.promptKey,
        question.promptArgs,
        question.promptNativeArgs,
      ) || question.question,
      explanation: translated(
        question.explanationKey,
        question.explanationArgs,
        question.explanationNativeArgs,
      ) || (question.explanationKey ? '' : question.explanation),
      right: question.rightLanguage === 'native'
        ? (question.right || []).map((item) => ({
            ...item,
            text: terms[String(item.text)] || item.text,
          }))
        : question.right,
      options: question.optionsLanguage === 'native'
        ? Object.fromEntries(
          Object.entries(question.options || {}).map(([key, value]) => [
            key,
            terms[String(value)] || value,
          ]),
        )
        : question.options,
    })),
  };
}

export { renderTemplate };
